import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { navigationClosed } from 'store/actions';

import config from 'configs';
import { SVG } from 'constants/miscellaneous';
// import { getCurrentTheme } from 'store/selectors';

// const { skinnings } = config;
// const skinning = config.currentSkin === 'asian' ? skinnings['asian'] : skinnings['classic'];

const Logo = ({ color, withSmall, className = '' }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  // const currentTheme = useSelector(getCurrentTheme);1

  // const image = (color || skinning[currentTheme]?.logo) === 'light' ? 'logo' : 'logo-w';
  const image = 'logo';

  const handleAppLogoClick = () => {
    history.push('/casino');

    dispatch(navigationClosed());
  };

  const logoExtension = !!config.content?.logoExtension?.length
    ? config.content?.logoExtension
    : SVG;

  const isSVG = logoExtension === SVG;

  const src = `/${image}.${logoExtension}`;

  return (
    <div onClick={handleAppLogoClick} className="logo-container">
      {isSVG ? (
        <img alt="logo" className={`App-logo ${className}`} src={src} />
      ) : (
        <picture>
          {withSmall && (
            <source media="(max-width:1024px)" srcSet={`/${image}-m.${logoExtension}`} />
          )}
          <img alt="logo" className={`App-logo ${className}`} src={src} />
        </picture>
      )}
    </div>
  );
};

export default Logo;
